import React, {useEffect} from 'react';
import {CssBaseline, Grid} from "@mui/material";
import CustomNavbar from "../components/CustomNavbar";
import LeftNavigation from "../components/LeftNavigation";
import {getEventsData} from "../store/actions/actions";
import {useSelector} from "react-redux";
import {useAppDispatch} from "../store/store";
import { BarChart } from '@mui/x-charts/BarChart';
import RightLogo from "../components/RightLogo";
import useWindowDimensions from "../utils/Helpers";
import {pieArcLabelClasses, PieChart} from "@mui/x-charts";
const StatisticsPage = () =>{
    const dispatch = useAppDispatch();
    const events = useSelector((state:any)=> state.app.events)
    const {width} = useWindowDimensions();
    useEffect(()=>{
        dispatch( getEventsData())
    },[dispatch])
    const getRandomColor =() => {
        let letters = '0123456789ABCDEF'.split('');
        let color = '#';
        for (let i = 0; i < 6; i++ ) {
            color += letters[Math.round(Math.random() * 15)];
        }
        return color;
    }
    const createBarChart = (key: string,height:number,width:number) =>{
        const array = events[key]

        const keys = Object.keys(array);
        const values:any = Object.values(array);
        return(
            <BarChart
                series={[
                    { data: values ,color: getRandomColor()},
                ]}
                height={height}
                width={width}
                xAxis={[{ data: keys, scaleType: 'band'}]}
            />
        )
    }
    const createGaugeChart = () =>{
        let count = 0;
        for(const property in events.pageViews){
            count += events.pageViews[property];
        }
        const data = [
            { value: count, label: 'Seitenaufrufe' },

        ];

        const size = {
            width: 400,
            height: 200,
        } as any;

        return <PieChart
            colors={[getRandomColor()]}
            series={[
                {
                    arcLabel: (item) => `${item.label} (${item.value})`,
                    arcLabelMinAngle: 45,
                    data,
                },
            ]}
            sx={{
                [`& .${pieArcLabelClasses.root}`]: {
                    fill: 'white',
                    fontWeight: 'bold',

                },
            }}
            {...size}
        />

    }



    const createPieChart = () =>{
        const data = [
            { value: events.uniqueClientIdsCount, label: 'Nutzer' },

        ];

        const size = {
            width: 400,
            height: 200,
        } as any;

        return <PieChart
            colors={[getRandomColor()]}
            series={[
                {
                    arcLabel: (item) => `${item.label} (${item.value})`,
                    arcLabelMinAngle: 45,
                    data,
                },
            ]}
            sx={{
                [`& .${pieArcLabelClasses.root}`]: {
                    fill: 'white',
                    fontWeight: 'bold',
                },
            }}
            {...size}
        />
    }


    return(
        <React.Fragment>
            <CssBaseline/>
            <CustomNavbar/>
            <Grid container style={{marginTop: 8}} spacing={3}>
                <Grid item xs={2}>
                    <LeftNavigation/>
                </Grid>
                <Grid item xs={8} style={{
                    textAlign: "center",
                    justifyContent: "center"
                }}>

                    <Grid container>
                        <Grid item xs={12}>
                            <h2>Total Seitenaufrufe</h2>
                            {events && createGaugeChart()}
                        </Grid>
                    </Grid>

                    <Grid container>
                        <Grid item xs={12}>
                            <h2>Anzahl der Nutzer</h2>
                            {events && createPieChart()}
                        </Grid>

                    </Grid>
                    <Grid container>
                        <Grid item xs={12}>
                            <h2>Einzigartige Länder</h2>
                            {events && createBarChart("country",350,width/2)}
                        </Grid>


                    </Grid>
                    <Grid container>
                        <Grid item xs={12}>
                            <h2>Einzigartige Städte</h2>
                            {events && createBarChart("city",350,width/2)}
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12}>
                            <h2>Einzigartige Geräte</h2>
                            {events && createBarChart("devices",350,width/2)}
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12}>
                            <h2>Anzahl Seitenaufrufe</h2>
                            {events && createBarChart("pageViews",350,width/2)}
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12}>
                            <h2>Einzigartige Browser</h2>
                            {events && createBarChart("browsers",350,width/2)}
                        </Grid>
                    </Grid>


                </Grid>
                <Grid item xs={2}>
                    <RightLogo/>
                </Grid>
            </Grid>
        </React.Fragment>
    )

}
export default StatisticsPage
